import { ItemTypes } from "../enums";

export class RelatedAddOnsGridModel {
    public id: string;
    public title: string;
    public name: string;
    public itemCount: number;
    public amount: string;
    public recurringPrice: string;
    public type: keyof typeof ItemTypes | null;
    constructor(data: Partial<RelatedAddOnsGridModel> = {}) {
        this.id = data.id || '';
        this.title = data.title || '';
        this.name = data.name || '';
        this.itemCount = data.itemCount || 0;
        this.amount = data.amount || '';
        this.recurringPrice = data.recurringPrice || '';
        this.type = data.type ? (data.type as keyof typeof ItemTypes) : null;
    }
}
